<template>
    <div class="cbs-booking-confirmation">
        <div class="success">
            <div class="icon">
                <svg width="84px" height="84px" viewBox="0 0 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                    <circle class="border" cx="42" cy="42" r="40" stroke-linecap="round" stroke-width="4" stroke="#000" fill="none"></circle>
                    <path class="checkmark" stroke-linecap="round" stroke-linejoin="round" d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338"
                          stroke-width="4" stroke="#000" fill="none">
                    </path>
                </svg>
            </div>

            <h3 class="title" data-tid="elements_examples.success.title">
                {{$t('forms.confirmation.yourBookingIsConfirmedText')}}
            </h3>
            <p class="message">
                <span data-tid="elements_examples.success.message">
                    {{$t('forms.confirmation.emailNotificationText')}}
                </span>
            </p>
        </div>

        <div>
            <button v-if="!ifInIframe" class="btn btn-success" @click="goToDetails">{{$t('actions.viewBooking')}}</button>
            <button v-if="ifInIframe" class="btn btn-success" @click="goToStart">{{$t('actions.newBooking')}}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BookingConfirmation",
        components: {},
        computed: {
            ifInIframe: function() { 
                return window.parent.location !== window.location;
            },
        },
        mounted(){
            this.$store.dispatch('account/tryGetToken');
        },
        beforeDestroy() {
            // reset booking state 
            this.$store.commit('booking/setInitialState');
            this.$store.commit('booking/setBookingType', this.$store.state.booking.configuration.defaultBookingType);
        },
        methods: {
            goToDetails: function() {
                let isAuthenticated = this.$store.state.account.isLoggedIn;
                const guid = this.$store.state.booking.bookingInfo.general.guid;
                const hash = this.$store.state.booking.bookingInfo.general.hash;
                if(isAuthenticated) {
                    this.$router.replace({name: 'reservationDetails', params: {id: guid}});
                }
                else {
                    this.$router.replace({ name: 'reservationSecureDetails', params: { hash: hash } });
                }
            },
            goToStart: function() {
                this.$store.commit('booking/setInitialState');
                this.$store.commit('booking/setBookingType', this.$store.state.booking.configuration.defaultBookingType);
            }
        }
    }
</script>

<style>
    .cbs-booking-confirmation {
        text-align: center;
        background-color: #fff;
        padding: 50px;
    }

        .cbs-booking-confirmation .success .icon .border {
            stroke: #abe9d2;
        }

        .cbs-booking-confirmation .success .icon .checkmark {
            stroke: #24b47e;
        }

        .cbs-booking-confirmation .success .title {
            margin-top: 45px;
            margin-bottom: 5px;
            color: #32325d;
            font-size: 16px !important;
        }

        .cbs-booking-confirmation .success .message {
            color: #8898aa;
            font-size: 13px !important;
        }
</style>